import type { Messages } from '../types'
import { adminCommerceMessages } from './admin-commerce'
import { trailerMessages } from './trailer'

export const ko = {
  adminCommerce: adminCommerceMessages.ko,
  trailerRefresh: trailerMessages.ko,
  home: {
    quotaFull: '구독 한도에 도달했습니다. 멤버십 플랜을 확인해 보세요.',
    search: '품번, 배우 또는 제목 검색',
    updates: '내 구독 소식',
    updatesBody: '구독한 배우의 새로운 작품을 여기서 확인하세요.',
    following: '내가 구독한 배우',
    followingBody: '배우를 선택하면 해당 배우의 소식만 볼 수 있어요.',
    discover: '가볍게 둘러보세요',
    discoverBody: '라이브러리에서 무작위로 골랐어요. 마음에 드는 작품을 찾아보세요.',
    shuffle: '다른 작품 보기',
    scrollPrevious: '{section}: 왼쪽으로 스크롤',
    scrollNext: '{section}: 오른쪽으로 스크롤',
    favorites: '즐겨찾기 다시 보기',
    favoritesBody: '저장한 작품 다시 보기 · 출시일순',
    noSubscriptionsBody: '좋아하는 배우 한 명부터 시작해 보세요. 구독하면 작품이 여기에 표시됩니다.',
    noUpdates: '구독한 배우의 새로운 작품 소식이 없어요',
    noUpdatesBody: '구독은 유지됩니다. 기다리는 동안 다른 작품도 둘러보세요.',
    noFavorites: '즐겨찾기가 아직 없어요. 마음에 드는 작품에서 하트를 누르면 나중에 여기서 찾을 수 있어요.',
    noDiscovery: '표시할 작품이 없어요. 나중에 다시 확인해 주세요.',
  },

  admin7: {
    overviewHint: '로컬 업무 데이터입니다. 외부 서비스 상태는 확인하지 않았습니다',
    orders: '주문 확인',
    config: '필수 설정',
    content: '콘텐츠 관리',
    tasks: '작업 관리',
    empty: '기록이 없습니다',
    unknown: '요청 결과를 알 수 없습니다. 기존 요청의 처리 내역을 확인하고 다시 제출하지 마세요.',
    recover: '기존 요청 확인',
    receipt: '확인된 처리 내역',
    newRequest: '다른 작업 시작',
    requestKey: '요청 키',
    role: '역할',
    saveRole: '역할 변경 확인',
    user: '일반 사용자',
    admin: '관리자',
    details: '자세히 보기',
    save: '저장',
    readBack: '현재 상태 다시 조회',
    loading: '읽는 중…',
    email: '이메일',
    userId: '사용자 ID',
    id: '기록 ID',
    status: '상태',
    source: '출처',
    editActressSource: '배우 수집 출처 수정',
    sourceIdentifier: 'JavBus 출처 ID',
    currentSource: '현재 출처 ID',
    sourceHint:
      '저장 시 출처만 수정하며 수집을 시작하지 않습니다. 프로필을 갱신하려면 별도로 배우 프로필 새로고침을 선택하세요.',
    sourceFormat: '영문, 숫자, 밑줄 또는 하이픈 1~80자. 첫 글자는 영문 또는 숫자',
    sourceConflict: '출처가 변경되었습니다. 현재 값을 다시 조회한 후 저장 여부를 결정하세요.',
    reloadSource: '출처 다시 조회',
    continueEditing: '편집 계속',
    trailerMaintenance: '개별 작품 예고편 관리',
    trailerHint:
      '선택한 작품만 처리합니다. 새 예고편 처리가 성공할 때까지 기존 파일을 유지합니다. 등록 후 작업 상태를 확인하거나 취소를 요청할 수 있습니다.',
    trailerMode: '예고편 소스 추가 방식',
    trailerAuto: '자동 검색',
    trailerUrl: '공개 예고편 URL',
    trailerFile: '로컬 예고편 파일',
    trailerUrlHint:
      'DMM, MGS, Caribbean 등 허용된 공개 예고편 경로를 지원합니다. 다른 출처는 로컬 파일을 사용하세요.',
    trailerFileHint: 'MP4 또는 MPEG-TS, 최대 200 MiB. 파일 내용은 서버에서 검증합니다.',
    uploading:
      '업로드 및 처리 내역을 확인하는 중입니다. 이 페이지를 유지하세요. 시간 초과 후에는 기존 작업만 조회하세요.',
    all: '전체',
    amount: '금액',
    created: '생성 일시',
    paid: '결제 일시',
    expires: '만료 일시',
    providerStatus: '결제 서비스 상태',
    merchantOrder: '가맹점 주문 번호',
    orderHint:
      'Payment 주문을 읽기 전용으로 확인합니다. 별도 Stars 원장은 포함하지 않으며 결제 조회나 혜택 지급을 실행하지 않습니다. 통화별로 표시합니다.',
    revenue: '이번 달 CCPayment 결제 완료 금액(USD)',
    revenueHint: 'UTC 월 기준, USD만 집계. Stars, CDKey 및 수동 부여 혜택 제외',
    limit: '일일 무료 가입 한도',
    translationUrl: '번역 서비스 주소',
    model: '번역 모델',
    translationKey: '번역 API 키',
    appId: 'CCPayment App ID',
    paymentKey: 'CCPayment 키',
    fiat: '가격 표시 법정 화폐 ID',
    coin: '가격 표시 코인 ID',
    configured: '설정됨. 비워 두면 유지',
    unset: '미설정',
    configHint:
      '키 원문은 조회할 수 없습니다. 비워 두면 유지됩니다. 저장 후 마스킹된 설정을 반환하며 외부 서비스 검증 완료를 의미하지는 않습니다.',
    recent: '최근 콘텐츠 수집',
    actressCrawl: '배우 작품 수집',
    videoRefresh: '작품 새로고침',
    actressRefresh: '배우 프로필 새로고침',
    translateVideo: '개별 작품 번역',
    translateBatch: '건수 제한 일괄 번역',
    kind: '작업',
    target: '대상 내부 ID',
    pages: '최대 페이지 수(1~10)',
    batchLimit: '일괄 처리 한도(1~50)',
    enqueue: '대기열 등록 확인',
    taskHint:
      '대기열 등록은 실행 완료를 의미하지 않습니다. 페이지를 떠나도 작업은 취소되지 않습니다. 취소는 선택한 작업에만 적용됩니다.',
    active: '활성 작업',
    history: '작업 이력',
    cancelTask: '이 작업 취소 요청',
    cancellation: '취소를 요청했습니다. 실행 측의 최종 상태를 기다리는 중입니다',
    progress: '처리 {processed} / {total} · 성공 {success} · 실패 {failed}',
    attempts: '시도 {attempts} / {max}',
    errorCode: '오류 코드',
    taskId: '작업 ID',
    searchActress: '등록된 배우 검색',
    searchVideo: '작품 품번 또는 제목 검색',
    searchBound: '2자 이상 입력하세요. 최대 20건을 표시합니다',
    noContent: '일치하는 콘텐츠가 없습니다. 검색어를 변경하세요',
    selectedContent: '선택됨: {name}',
    search: '조회',
    select: '선택',
    unavailableStar: 'JavBus Star ID가 없습니다',
    translationTitle: '번역 제목 수동 수정',
    videoId: '작품 내부 ID',
    locale: '언어',
    title: '제목',
    translationSaved: '번역 제목을 저장했습니다',
    viewUser: '혜택 관리',
    snapshot: '현재 혜택 종료 일시',
    manualHint:
      '기본적으로 유효한 혜택 종료일 뒤에 기간을 추가합니다. 만료된 경우 현재 시점부터 계산합니다. 평생 혜택은 하향 변경할 수 없습니다.',
    months: '개월 수(1~120)',
    expectedEnd: '예상 종료 일시(서버 처리 결과 기준)',
    membershipConflict: '혜택 상태 또는 요청이 충돌했습니다. 사용자 상태를 다시 조회한 후 진행하세요.',
    replaceLifetimeEffect: '대체 후에는 만료일 없는 평생 혜택이 적용됩니다.',
    replaceFiniteEffect:
      '대체 후 이번 적용 시점부터 {months}개월로 계산됩니다. 현재 남은 기간은 유지되지 않으며 혜택 기간이 줄어들 수 있습니다.',
    append: '혜택 기간 추가',
    replace: '혜택 대체',
    mode: '혜택 작업',
    reason: '작업 메모',
    replaceConfirm: '선택한 플랜으로 현재 혜택을 대체하며 유효기간이 줄어들 수 있음을 확인합니다',
  },
  brand: { name: 'JAV Tracker', admin: '관리자 페이지' },
  nav: {
    today: '오늘',
    discover: '발견',
    library: '라이브러리',
    search: '검색',
    me: '마이페이지',
    searchPlaceholder: '품번, 배우, 태그 검색',
    account: '계정 메뉴',
    logout: '로그아웃',
    admin: '관리자 페이지',
    language: '언어',
    back: '뒤로',
    backTo: '{target}(으)로 돌아가기',
    skipToContent: '본문으로 바로 가기',
  },
  common: {
    retry: '다시 시도',
    loading: '불러오는 중…',
    loadMore: '더 보기',
    loadError: '불러오지 못했습니다. 다시 시도해 주세요',
    networkError: '네트워크에 연결할 수 없습니다',
    cancel: '취소',
    apply: '적용',
    clearAll: '모두 지우기',
    confirm: '확인',
    close: '닫기',
    copy: '복사',
    copied: '복사됨',
    copyFailed: '복사하지 못했습니다. 직접 선택하여 복사해 주세요',
    videosCount: '{count}편',
    viewAll: '전체 보기',
    upgrade: '업그레이드',
    end: '마지막 항목입니다',
    autoPaused: '{count}편을 불러왔습니다. 계속 보려면 더 보기를 눌러 주세요',
    unknownOutcome: '요청 결과를 알 수 없어 서버에서 확인하는 중입니다…',
    unknownPending: '요청 결과가 아직 확인되지 않았습니다. 상태를 조회한 후 계속해 주세요.',
    verifyState: '상태 조회',
    mockNotice: 'Mock 데이터 미리보기 · 모든 콘텐츠는 합성 예시입니다',
  },
  video: {
    retranslate: '다시 번역',
    retranslateHint: '이 작품의 제목을 다시 번역합니다. 수동 수정은 유지되며 완료 후 번역이 갱신됩니다.',
    new: '신작',
    magnets: '마그넷 {count}',
    noMagnets: '마그넷 대기 중',
    trailer: '예고편',
    solo: '단독 출연',
    favorite: '즐겨찾기',
    favorited: '즐겨찾기됨',
    unfavorite: '즐겨찾기 해제',
    copyCode: '품번 복사',
    coverAlt: '{code} 표지',
    coverFallback: '표지',
    releaseDate: '출시일',
    duration: '재생 시간',
    minutes: '{count}분',
    maker: '제작사',
    series: '시리즈',
    cast: '출연',
    tags: '태그',
    translated: '번역',
    original: '일본어 원문',
    playTrailer: '예고편 재생',
    closeTrailer: '예고편 닫기',
    trailerLabel: '{code} 예고편',
    trailerError: '예고편을 불러오거나 재생하지 못했습니다. 다시 시도해 주세요.',
    trailerUnsupported:
      '현재 브라우저는 이 예고편 형식을 지원하지 않습니다. MediaSource를 지원하는 브라우저를 사용해 주세요.',
    trailerPlayBlocked: '브라우저가 자동 재생을 중단했습니다. 아래 재생 버튼을 사용해 주세요.',
    trailerHint: '예고편은 클릭한 뒤에만 불러옵니다.',
    noTrailer: '예고편이 없습니다',
    copyBest: '추천 마그넷 복사',
    bestMeta: '{size} · 시더 {seeders} · {source}',
    bestRule: '시더 수와 용량을 기준으로 자동 선택',
    noMagnetYet: '마그넷이 없습니다. 새로고침해 보세요',
    allMagnets: '전체 마그넷',
    magnetCount: '{count}개',
    refreshMagnets: '마그넷 새로고침',
    refreshQuota: '오늘 남은 횟수 {remaining}/{limit}',
    refreshing: '새로고침 중…',
    colName: '이름',
    colSize: '용량',
    colSeeders: '시더',
    colSource: '출처',
    best: '추천',
    notFound: '작품을 찾을 수 없습니다',
    notFoundBody: '품번이 잘못되었거나 아직 등록되지 않았을 수 있습니다. 온라인 검색을 해 보세요.',
  },
  actress: {
    recrawl: '다시 수집',
    recrawlHint: '최근 작품을 수집하고 저장합니다(최대 5페이지). 작업 종료 후 작품 목록을 갱신합니다.',
    subscribe: '구독',
    subscribed: '구독 중',
    pending: '확인 중…',
    unknown: '다시 확인',
    unsubscribe: '구독 취소',
    works: '작품',
    soloOnly: '단독 출연',
    withCompilations: '모음집 포함',
    pushing: '신작 소식을 Telegram으로 알려 드려요',
    pushOff: 'Telegram을 연결하면 신작 알림을 받을 수 있어요',
    debut: '데뷔',
    birthday: '생년월일',
    height: '키',
    measurements: '신체 사이즈',
    videoTotal: '작품',
    limitReached: '무료 플랜에서는 최대 5명의 배우를 구독할 수 있어요',
    notFound: '배우를 찾을 수 없습니다',
  },
  today: {
    title: '오늘의 새 소식',
    summary: '마지막 방문 이후 신작 {count}편 · 배우 {actresses}명 구독 중',
    all: '전체',
    manage: '구독 관리',
    hasMagnets: '마그넷 있음',
    hasTrailer: '예고편 있음',
    unfavorited: '즐겨찾기 안 함',
    sortRelease: '출시일순',
    today: '오늘',
    yesterday: '어제',
    groupCount: '{count}편',
    emptyNoSubs: '구독한 배우가 아직 없어요',
    emptyNoSubsBody: '구독하면 배우의 신작이 출시일순으로 여기에 표시됩니다.',
    goDiscover: '배우 찾아보기',
    emptyFiltered: '현재 조건에 맞는 작품이 없어요',
    emptyFilteredBody: '조건을 바꾸거나 필터를 지우고 모든 소식을 확인해 보세요.',
    quotaTitle: '무료 플랜 · 배우 구독',
    quotaFull: '한도에 도달했습니다. 멤버십은 무제한 구독 및 광고 제거를 제공합니다',
    viewPlans: '멤버십 플랜 보기',
  },
  discover: {
    title: '발견',
    videos: '작품',
    actresses: '배우',
    tags: '태그',
    filter: '필터',
    filterCount: '필터 · {count}',
    filterDraft: '미적용 조건',
    applied: '적용됨:',
    onlyShow: '표시할 작품',
    solo: '단독 출연 작품',
    hasMagnets: '마그넷 있음',
    hasTrailer: '예고편 있음',
    favorited: '내 즐겨찾기',
    releaseWindow: '출시 시기',
    anyTime: '전체 기간',
    days30: '최근 30일',
    thisYear: '올해',
    tag: '태그',
    sortLabel: '작품 정렬',
    sortNewest: '출시일 · 최신순',
    sortOldest: '출시일 · 오래된순',
    sortCrawledNewest: '수집일 · 최신순',
    sortCrawledOldest: '수집일 · 오래된순',
    pageAt: '{page}페이지를 보고 있어요',
    jump: '이동',
    jumpLabel: '페이지 번호로 이동',
    actressFilter: '이름, 일본어 이름, 로마자',
    all: '전체',
    subscribedOnly: '구독 중',
    unsubscribedOnly: '미구독',
    hotTags: '인기 태그',
    hotTagsHint: '전체 사이트 즐겨찾기 수 기준',
    searchTags: '전체 태그 검색',
    expand: '나머지 {count}개 펼치기',
    collapse: '접기',
    tagFilterActive: '태그: {name}',
  },
  tagCategory: {
    QUALITY_FORMAT: '화질 및 형식',
    RELEASE_LABEL: '출시 레이블',
    BODY_PERSONA: '체형 및 캐릭터',
    ROLE_COSTUME: '역할 및 의상',
    RELATION_CAST: '관계 및 출연진',
    GENRE_SCENARIO: '장르 및 상황',
    PLAY_FETISH: '플레이 및 취향',
    OTHER: '기타',
  },
  library: {
    title: '라이브러리',
    favorites: '즐겨찾기 작품 · {count}',
    favoritesTab: '즐겨찾기 작품',
    subscriptions: '구독한 배우 · {count}',
    favoritedAt: '{actress}',
    latest: '최신 {code}',
    quota: '무료 플랜 한도',
    emptyFavorites: '즐겨찾기한 작품이 아직 없어요',
    emptyFavoritesBody: '작품 카드에서 하트를 누르면 즐겨찾기할 수 있어요.',
    emptySubs: '구독한 배우가 아직 없어요',
  },
  search: {
    title: '검색',
    placeholder: '품번, 배우, 태그 검색',
    scopeAll: '전체',
    scopeVideos: '작품',
    scopeActresses: '배우',
    scopeTags: '태그',
    exact: '품번 정확히 일치',
    videos: '작품',
    actresses: '배우',
    tags: '태그',
    open: '↵ 열기',
    recent: '최근 검색',
    clearRecent: '지우기',
    noLocal: '원하는 작품이 없나요? JavBus에서 온라인으로 검색해 보세요',
    onlineHint: '결과는 라이브러리에 추가됩니다. 캐시가 있으면 횟수가 차감되지 않습니다',
    onlineButton: '「{keyword}」 온라인 검색',
    onlineQuota: '오늘 남은 횟수 {remaining}/{limit}',
    onlineRunning: '온라인 검색 중… {count}편을 찾았어요',
    onlineDone: '온라인 검색 완료. {count}편을 찾았어요',
    onlineCancel: '중지',
    onlineCancelled: '결과 수신을 중지했습니다. 이미 등록된 작품은 삭제되지 않습니다',
    onlineExhausted: '오늘의 온라인 검색 횟수를 모두 사용했어요',
    keyboardHints: '↑↓ 선택 · ↵ 열기 · Esc 닫기',
    typeToSearch: '2자 이상 입력하세요',
    searching: '검색 중…',
    noResult: '등록된 데이터에서 일치하는 결과가 없습니다',
    kindCode: '품번',
    kindVideo: '작품',
    kindActress: '배우',
    kindTag: '태그',
  },
  me: {
    defaultLanguage: '기본 언어',
    defaultLanguageHint:
      'Telegram 신작 알림과 상세 링크에 사용됩니다. 설정하지 않으면 중국어 번체가 사용됩니다. 화면 언어는 별도로 변경할 수 있습니다.',
    defaultLanguageSaved: '기본 언어가 저장되었습니다',

    title: '마이페이지',
    overview: '개요',
    membership: '멤버십 및 결제',
    telegram: 'Telegram 알림',
    cdkey: 'CDKey 등록',
    security: '언어 및 보안',
    free: '무료 플랜',
    active: '멤버십',
    expired: '만료됨',
    lifetime: '평생 멤버십',
    until: '유효기간: {date}',
    verifyBanner: '이메일 인증이 필요합니다. CDKey 등록, 멤버십 구매 및 Telegram 연결 전에 인증해 주세요.',
    resendVerify: '인증 이메일 다시 보내기',
    verifySent: '인증 이메일이 발송 대기열에 등록되었습니다. 잠시 후 확인해 주세요',
    quotaSubs: '배우 구독',
    quotaOnline: '온라인 검색 · 오늘',
    quotaRefresh: '마그넷 새로고침 · 오늘',
    perks:
      '멤버십은 무제한 구독과 이용 한도, 광고 제거를 제공합니다. 암호화폐 결제 확인 후 자동으로 활성화됩니다.',
    monthly: '월간',
    yearly: '연간',
    lifetimePlan: '평생',
    perMonth: '/ 월',
    perYear: '/ 년',
    oneTime: '일회성',
    bestValue: '가장 합리적인 선택',
    choose: '{plan} 선택',
    price: '[가격]',
    orderPaid: '결제가 완료되어 멤버십 혜택이 활성화되었습니다.',
    orderCancelled: '주문이 종료되었습니다. 이 주문으로 멤버십이 활성화되지 않았습니다.',
    orderUnknown: '결제 주문을 아직 확인 중입니다. 기존 주문을 조회하고 중복으로 생성하지 마세요.',
    goCheckout: '결제하러 가기',
    checkOrder: '기존 주문 조회',
    tgUnknown:
      '작업 결과가 아직 확인되지 않았습니다. 연결 상태를 확인하고 자동으로 요청을 다시 보내지 마세요.',
    tgRegenerate: '다시 발급하면 기존 연결 코드가 대체됩니다.',
    tgCopy: '연결 명령 복사',
    tgOpenBot: '봇 열기',
    tgCheck: '연결 상태 확인',
    cdkeyConfirm: '기존 코드 등록 요청 확인',
    cdkeyUnknown:
      '코드 등록 결과를 알 수 없어 멤버십 상태를 다시 조회했습니다. 기존 요청을 확인하고 다른 코드로 바꾸어 다시 제출하지 마세요.',
    orderPending:
      '주문이 생성되어 결제 확인을 기다리고 있습니다. 페이지를 닫아도 입금 처리는 계속됩니다. 혜택은 서버 확인을 기준으로 적용됩니다.',
    tgBound: '@{username} 연결됨',
    tgUnbound: '연결 안 됨',
    tgBody: '구독한 배우의 신작을 알려 드려요. 처음 연결하면 7일 멤버십을 받을 수 있어요.',
    tgRewarded: '첫 연결 보상을 이미 받았어요',
    tgTest: '테스트 메시지 보내기',
    tgTestSent: '테스트 메시지가 발송 대기열에 등록되었습니다',
    tgUnbind: '연결 해제',
    tgBind: '연결 코드 받기',
    tgCode: 'Telegram에서 봇에 보내세요: {code}',
    cdkeyLabel: '등록 코드 입력',
    cdkeyRedeem: '등록',
    cdkeyNeedVerify: '이메일 인증 후 이용할 수 있어요',
    cdkeyDone: '코드가 등록되어 멤버십이 활성화되었습니다',
    cdkeyHint: 'Mock 테스트 코드: DEMO-CDKEY-2026',
    language: '화면 언어',
    changePassword: '비밀번호 변경',
    logout: '로그아웃',
  },
  auth: {
    login: '로그인',
    register: '회원가입',
    email: '이메일',
    password: '비밀번호',
    optional: '선택 사항',
    forgot: '비밀번호를 잊으셨나요?',
    submitLogin: '로그인',
    submitRegister: '계정 만들기',
    demoLink: '먼저 방문자 데모 둘러보기 →',
    passwordRule: '영문과 숫자를 포함한 8자 이상, 최대 72바이트(한글과 이모지는 여러 바이트를 사용)',
    headline: '좋아하는 배우를 구독하고,\n신작 소식을 빠르게 받아보세요.',
    mockHint: 'Mock 계정: demo@example.com 또는 admin@example.com, 비밀번호: password1',
    terms: '이용약관',
    privacy: '개인정보 처리방침',
    forgotTitle: '비밀번호 찾기',
    forgotBody:
      '가입한 이메일을 입력하세요. Telegram이 연결된 계정은 Telegram으로, 그 외에는 이메일로 전송합니다.',
    forgotSubmit: '재설정 링크 보내기',
    forgotDoneTitle: '요청이 제출되었습니다',
    forgotDone:
      '조건에 맞는 계정이면 재설정 링크 발송을 예약합니다. 이 안내는 수신 완료를 의미하지 않습니다. {seconds}초 후 다시 요청할 수 있습니다.',
    forgotResend: '다시 보내기',
    forgotPrivacy: '계정 존재 여부를 노출하지 않도록 모든 이메일에 같은 안내를 표시합니다.',
    backToLogin: '로그인으로 돌아가기',
    forgotHeadline: '비밀번호를 잊어도,\n구독한 배우는 그대로 있어요.',
    resetTitle: '새 비밀번호 설정',
    resetBody: '완료하면 모든 기기에서 로그아웃됩니다.',
    newPassword: '새 비밀번호',
    confirmPassword: '한 번 더 입력',
    show: '표시',
    hide: '숨기기',
    ruleLength: '8자 이상(이모지 등은 2자로 계산될 수 있음)',
    ruleBytes: '최대 72바이트(한글과 이모지는 여러 바이트를 사용)',
    ruleMix: '영문과 숫자 포함',
    ruleMatch: '두 번 입력한 값이 일치',
    resetSubmit: '새 비밀번호 저장',
    resetExpired: '링크가 만료되었거나 이미 사용되었나요?',
    resetAgain: '다시 요청하기 →',
    resetDone: '비밀번호가 변경되었습니다. 다시 로그인해 주세요',
    resetHeadline: '새 비밀번호로 바꾸면,\n다른 기기는 자동으로 로그아웃돼요.',
    verifyingTitle: '이메일 인증 중…',
    verifiedTitle: '이메일 인증 완료',
    verifiedBody: '이제 CDKey 등록, 멤버십 구매 및 Telegram 연결을 통한 신작 알림을 이용할 수 있습니다.',
    goBindTelegram: 'Telegram 연결하기',
    backToday: '오늘로 돌아가기',
    verifyFailedTitle: '이메일 인증이 완료되지 않았습니다',
    verifyFailedBody:
      '오류 내용을 확인하세요. 링크가 만료된 경우 로그인 후 인증 이메일을 다시 요청할 수 있습니다.',
    registerEmailFailed:
      '계정은 생성되었으나 인증 이메일의 대기열 등록은 확인되지 않았습니다. 계정 페이지에서 다시 요청할 수 있습니다.',
    alreadyVerified: '이메일 인증됨',
    currentPassword: '현재 비밀번호',
    logoutAll: '모든 웹 세션에서 로그아웃',
    logoutAllDone: '웹 세션에서 로그아웃되었습니다. 다시 로그인해 주세요',
    resendVerify: '인증 이메일 다시 보내기',
    goLogin: '로그인하기',
  },
  jobs: {
    nextPage: '다음 페이지 온라인 검색',
    cancelling: '취소를 요청했습니다. 확인을 기다리고 있습니다',
    confirmRequest: '기존 요청 확인',
    resume: '작업 다시 연결',
    unknown:
      '제출 결과가 아직 확인되지 않았습니다. 기존 요청 확인 시 같은 요청 번호를 사용하므로 이미 있는 작업을 중복 생성하지 않습니다.',
    disconnected:
      '작업이 계속 실행 중일 수 있습니다. 연결이 끊겨도 작업은 취소되지 않습니다. 다시 연결하여 상태를 확인할 수 있습니다.',
    partial: '사용 가능한 결과를 일부 가져왔습니다. 사용 가능한 결과를 기준으로 이용 횟수가 계산됩니다.',
  },
  onboarding: {
    step1: '배우 선택',
    step2: '작품 즐겨찾기',
    step3: 'Telegram 연결',
    step4: '완료',
    progress: '{current} / 1 · {label}',
    skip: '안내 건너뛰기',
    title: '먼저 구독하고 싶은 배우를 골라보세요',
    body: "3명부터 시작해 보세요. 최대 5명까지 선택할 수 있어요. 신작은 '오늘'에 표시되며 Telegram으로도 알림을 받을 수 있어요.",
    selected: '{count} / 5명 선택',
    continue: '{count}명 구독하고 계속',
    needOne: '1명 이상 선택하세요',
  },
  landing: {
    navigation: '홈 내비게이션',
    eyebrow: '나만의 신작 체크리스트',
    signupFree: '무료 계정 만들기',
    heroA: '좋아하는 배우를 구독하고,',
    heroB: '신작을 놓치지 마세요.',
    heroBody:
      '구독한 배우, 간직하고 싶은 작품, 신작 소식을 한곳에 모으세요. JAV Tracker를 열면 나와 관련된 소식부터 확인할 수 있어요.',
    seePreview: '신작 소식 확인 방법 보기',
    loginHint:
      '로그인하면 작품을 둘러보고 구독과 즐겨찾기를 관리할 수 있어요. 가입 가능 인원은 가입 페이지에서 확인하세요.',
    previewTitle: '내 구독 소식',
    example: '신작 소식 예시',
    sampleOne: '구독한 배우의 신작을 한곳에서',
    sampleTwo: '관심 있는 작품은 바로 즐겨찾기',
    sampleAvailable: '마그넷 등록됨',
    previewNote: 'Telegram을 연결하면 신작 알림도 받을 수 있어요.',
    exampleNote:
      '위 내용은 기능을 설명하기 위한 예시입니다. 품번과 콘텐츠는 합성 예시이며 실시간 업데이트가 아닙니다.',
    how: '사용 방법',
    howTitle: '구독으로 시작해 신작 확인을 일상으로.',
    f1Title: '구독하고 싶은 배우 찾기',
    f1Body: '배우 이름, 품번 또는 제목을 검색하고 작품과 배우 프로필을 확인하세요.',
    f2Title: '구독하고 나만의 소식 만들기',
    f2Body:
      '구독한 배우를 한곳에서 관리하고 작품을 출시일순으로 확인하세요. 마음에 드는 작품은 따로 즐겨찾기할 수 있어요.',
    f3Title: '직접 확인하거나 알림 받기',
    f3Body: '홈에서 구독 소식을 확인하세요. 직접 Telegram을 연결하면 신작 알림도 받을 수 있어요.',
    pricingTitle: '무료로 시작하고 필요할 때 멤버십 선택',
    pricingBody:
      '무료 계정으로 작품 탐색, 즐겨찾기 및 배우 구독을 이용할 수 있어요. 구독과 온라인 작업에는 한도가 있으며 현재 이용 가능한 횟수는 로그인 후 확인할 수 있어요.',
    membershipBody:
      '더 많은 이용 한도가 필요하면 멤버십 플랜을 확인하세요. 실제 혜택, 가격 및 구매 가능 여부는 계정 내 표시를 기준으로 합니다.',
    viewMembership: '로그인하고 멤버십 플랜 보기',
    startTitle: '좋아하는 배우 한 명부터 구독해 보세요.',
    startBody: '다음에 홈을 열 때 기대할 소식이 생기도록요.',
    sessionError: '현재 로그인 상태를 확인할 수 없습니다. 홈 내용은 계속 읽을 수 있습니다.',
    termsTitle: '서비스 안내',
    termsBody:
      'JAV Tracker는 성인을 위한 작품 정보 관리 및 신작 추적 도구입니다. 제3자 작품 정보는 지연되거나 유효하지 않을 수 있습니다. 거주 지역에서 허용하는 범위 내에서 이용하세요.',
    termsContact: '전체 이용약관 요청 ↗',
    privacyTitle: '개인정보 안내',
    privacyBody:
      '로그인 상태 유지에 Cookie를 사용하며 구독과 즐겨찾기는 계정에 연결됩니다. Telegram 연결은 직접 활성화하고 계정에서 해제할 수 있습니다. 이 안내는 기능 설명입니다. 전체 정책이나 데이터 관련 요청은 고객지원으로 문의하세요.',
    privacyContact: '개인정보 처리방침 및 데이터 문의 ↗',
    rights: '© JAV Tracker',
  },
  admin: {
    overview: '대시보드',
    users: '사용자',
    crawler: '크롤러 콘솔',
    groupOverview: '개요',
    groupUsers: '사용자 및 수익',
    groupContent: '콘텐츠',
    groupCrawl: '수집',
    groupSystem: '시스템',
    revenue: '수익',
    cdkeys: 'CDKey',
    videos: '작품',
    aliases: '배우 별칭',
    translations: '번역 작업',
    crawlerLogs: '크롤러 로그',
    config: '시스템 설정',
    monitor: '모니터링',
    notInScope: '첫 버전에서는 아직 제공되지 않습니다',
    backToApp: '← 앱으로 돌아가기',
    refresh: '새로고침',
    telegramTest: 'Telegram 테스트 보내기',
    statVideos: '작품',
    statActresses: '배우',
    statUsers: '사용자',
    statRevenue: '이번 달 수익',
    statTranslations: '번역 대기',
    statQueue: '백그라운드 대기열 실패',
    delta24h: '+{count} 최근 24시간',
    delta7d: '+{count} 최근 7일',
    activeMembers: '유효한 멤버십 회원 {count}명',
    sinceMonth: '베이징 시간 기준 월초부터',
    ingest: '새로 등록된 작품 · 최근 14일',
    sample: 'Mock 데이터',
    deps: '외부 서비스',
    recentJobs: '최근 백그라운드 작업',
    usersSub: '사용자 {count}명 · 관리자는 이메일 인증 제한을 받지 않습니다',
    searchEmail: '이메일 검색',
    filterAll: '전체',
    filterActive: '유효한 멤버십',
    filterFree: '무료',
    filterExpired: '만료됨',
    filterAdmin: '관리자',
    colEmail: '이메일',
    colRole: '역할',
    colMembership: '멤버십',
    colTelegram: 'Telegram',
    colSubs: '구독',
    colCreated: '가입일',
    roleAdmin: '관리자',
    roleUser: '사용자',
    bound: '연결됨',
    unbound: '연결 안 됨',
    activate: '멤버십 활성화',
    activateTitle: '멤버십 수동 활성화',
    current: '현재: {status}',
    activateFooter: '플랜 정가를 수익에 반영하고 감사 로그에 기록합니다.',
    activateConfirm: '활성화 확인',
    activateDone: '{email} 계정을 활성화했습니다',
    pageOf: '{page}페이지',
    prev: '이전 페이지',
    next: '다음 페이지',
    crawlerSub: '내장 스케줄러가 3시간마다 등록 · normal 분류만 대상',
    startIncremental: '전체 사이트 증분 수집 시작',
    jobTitle: '작품 수집 · normal',
    running: '실행 중',
    finished: '이번 처리 완료',
    stop: '중지 요청',
    slice: '현재 slice · 작품 {processed} / {total}',
    sliceMeta: '페이지 {pages} / {pageLimit} · {elapsed}s / {budget}s',
    okCount: '이번 성공 수',
    failCount: '실패',
    failHint: '다음 slice에서 다시 시도합니다',
    notifyCount: '신작 알림',
    notifyHint: '알림 대기열에 등록됨',
    slots: '전체 동시 실행 슬롯',
    slotsHint: '인스턴스 간 공유',
    crawlActress: '배우 개별 수집',
    starLabel: 'JavBus 배우 ID 또는 이름',
    enqueue: '대기열에 추가',
    enqueueDone: '대기열에 추가됨: {jobId}',
    enqueueHint: '같은 배우의 작업이 이미 있으면 기존 작업을 반환하며 중복 생성하지 않습니다.',
    liveLogs: '실시간 로그',
    liveHint: '5초마다 갱신',
    forbidden: '관리자 권한이 필요합니다',
  },
  membership: {
    FREE: '무료',
    ACTIVE: '유효',
    EXPIRED: '만료됨',
    MONTHLY: '월간',
    YEARLY: '연간',
    LIFETIME: '평생',
  },
} satisfies Messages
